'use strict';

/* Views */
import AmenityReservationList from './amenity/list/reservation-list.component';
import AmenityReservationAdmin from './amenity/admin/reservation-admin.component';
import EventReservationShow from './event/show/event-reservation-show.component';
import EventReservationList from './event/list/event-reservation-list.component';
import EventReservationEdit from './event/edit/event-reservation-edit.component';
import EventReservationAdmin from './event/admin/event-reservation-admin.component';
import EventReservationCalendar from './event/calendar/event-calendar.component';
import ReservationOverview from './overview/reservation-overview.component';

/* Components */
import AmenityReservationAddComponent from '../../components/reservation-add/reservation-add.component';

/* Services */
import ReservationService from '../../services/reservation/reservation.service';
import ReservableEventService from '../../services/reservable-event/event.service';

export default angular.module('conduuApp.reservation', [AmenityReservationList, AmenityReservationAdmin, AmenityReservationAddComponent,
  EventReservationShow, ReservationService, ReservableEventService, EventReservationList, EventReservationEdit, EventReservationAdmin,
  EventReservationCalendar, ReservationOverview])
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/index.js